import { FormHTMLAttributes, ReactNode, RefObject } from 'react';

interface Props extends FormHTMLAttributes<HTMLFormElement> {
  children: ReactNode;
  ref?: RefObject<HTMLFormElement | null>;
}

const Form = ({ children, ...props }: Props) => (
  <form {...props}>{children}</form>
);

Form.displayName = 'Form';

export default Form;
